import { APP_VERSION } from "@core/constants";

export class BatchDTO {
  constructor(data = {}) {
    this.operatingSystem = data.operatingSystem;
    this.installationId = data.installationId;
    this.osVersion = data.osVersion;
  }

  postActivateBatchData() {
    return {
      device_os: this.operatingSystem,
      installation_id: this.installationId,
      app_version: APP_VERSION,
      device_version: this.osVersion,
    };
  }
}
